import pageStyles from "@/css/PageContent.module.css";
import PropTypes from "prop-types";
import styles from "./PageContainer.module.css";

const PageContainer = (props) => {
  return <div className={styles.container}>{props.children}</div>;
};

PageContainer.propTypes = {
  children: PropTypes.node,
};

export default PageContainer;
